/* eslint-disable no-useless-escape */
/**
 * It returns true if the text is a valid URL, and false otherwise
 * @param [text] - The text to be validated.
 * @returns A boolean value.
 */
export const isValidUrl = (text = '') => {
  const urlRegex = /^(https?|ftp):\/\/[^\s$.?#].[^\s]*$/;
  return urlRegex.test(text);
};
